import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import ReservationForm from '../components/ReservationForm';
import { Clock, Users, ArrowRight, Images } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from '../components/ui/button';
import api from '../lib/api';
import Lightbox from '../components/Lightbox';
import ExcursionBookingDialog from '../components/ExcursionBookingDialog';

const ExcursionsPage = () => {
  const { t, lang } = useLanguage();
  const [items, setItems] = useState([]);
  const [lbOpen, setLbOpen] = useState(false);
  const [lbImages, setLbImages] = useState([]);
  const [bookExc, setBookExc] = useState(null);

  useEffect(() => {
    api.get('/excursions').then(r => setItems(r.data)).catch(() => {});
    window.scrollTo(0, 0);
  }, []);

  const handleReserve = (exc) => {
    setBookExc(exc);
  };

  const openGallery = (exc) => {
    const imgs = exc.gallery && exc.gallery.length ? exc.gallery : (exc.image ? [exc.image] : []);
    setLbImages(imgs);
    setLbOpen(true);
  };

  return (
    <div className="bg-[#0a0a0a] min-h-screen">
      <Header />
      <section className="pt-36 pb-12 bg-gradient-to-b from-black via-[#0a0a0a] to-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-[#ff6b1a] text-sm font-bold tracking-[0.2em] uppercase">{t.excursions.tag}</span>
          <h1 className="text-5xl md:text-6xl font-black text-white mt-3 mb-4">{t.excursions.title}</h1>
          <p className="text-white/60 max-w-3xl mx-auto text-lg">{t.excursions.subtitle}</p>
        </div>
      </section>

      <section className="pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
            {items.map((exc) => {
              const galleryCount = (exc.gallery && exc.gallery.length) || (exc.image ? 1 : 0);
              return (
              <div key={exc.id} className="glass-card rounded-xl overflow-hidden card-hover group">
                <div className="relative h-56 overflow-hidden cursor-pointer" onClick={() => galleryCount > 0 && openGallery(exc)}>
                  <img src={exc.image} alt={exc.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  <div className="absolute top-4 right-4 bg-[#ff6b1a] text-white px-4 py-1.5 rounded-full font-bold text-sm shadow-lg">${exc.price.toFixed(0)} USD</div>
                  {galleryCount > 1 && (
                    <div className="absolute bottom-3 left-3 bg-black/70 backdrop-blur text-white px-2.5 py-1 rounded-md text-xs font-semibold flex items-center gap-1.5">
                      <Images className="w-3.5 h-3.5 text-[#ff6b1a]" /> {galleryCount} fotos
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white mb-3">{lang === 'en' && exc.title_en ? exc.title_en : exc.title}</h3>
                  <p className="text-white/60 text-sm leading-relaxed mb-5 line-clamp-3">{lang === 'en' && exc.description_en ? exc.description_en : exc.description}</p>
                  <div className="flex items-center gap-4 text-xs text-white/50 mb-5">
                    <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5 text-[#ff6b1a]" /> {lang === 'en' && exc.duration_en ? exc.duration_en : exc.duration}</span>
                    <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5 text-[#ff6b1a]" /> {t.excursions.groups}</span>
                  </div>
                  <Button onClick={() => handleReserve(exc)} className="btn-orange border-0 w-full rounded-md gap-2">
                    {t.excursions.reserve} <ArrowRight className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            );})}
          </div>
        </div>
      </section>

      <ReservationForm />
      <Footer />
      <WhatsAppButton />
      <Lightbox open={lbOpen} onClose={() => setLbOpen(false)} images={lbImages} />
      <ExcursionBookingDialog excursion={bookExc} open={!!bookExc} onOpenChange={(v) => !v && setBookExc(null)} />
    </div>
  );
};

export default ExcursionsPage;
